module.exports = __webpack_public_path__ + "static/media/viber.72020b1a.svg";